var map = {
	"./a.png": "fe33",
	"./b.png": "36c4",
	"./breath_blue.png": "2fc4",
	"./breath_green.png": "ba19",
	"./breath_no_visits.png": "8841",
	"./breath_orange.png": "0b01",
	"./breath_red.png": "29f8",
	"./breath_yellow.png": "a37f",
	"./c.png": "b7fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8cba";